import React, { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import IconTick from 'components/icons/iconTick';
import JBImage from 'components/essentials/JBImage';
import useScreen from 'hooks/useScreen';
import getOrientationOptionIcon from '../helpers/getOrientationOptionIcon';

const PDPFullWidthImageAndTextOption = ({
  content = {},
  onClickAction,
  onHoverAction,
  valueId,
  sku,
  optionValueName = '',
  selectedId,
}) => {
  const { isMobile } = useScreen();

  const location = useLocation();

  const { image = null, customItem = null } = useMemo(
    () => getOrientationOptionIcon(optionValueName, sku, location.pathname),
    [location.pathname, optionValueName, sku]
  );

  const isSelected = selectedId === valueId;

  return (
    <button
      type="button"
      className={classNames(
        '[background:none] w-full flex flex-row border border-solid border-white relative hover:cursor-pointer',
        {
          'shadow-[inset_0_0_0_2px_#424242,inset_0_0_0_4px_#fff]': isSelected,
          'hover:border-gray-dark': !isSelected,
          'hover:border-white': isSelected,
        }
      )}
      onClick={() => {
        if (isMobile) {
          onHoverAction(true, valueId);
        }
        onClickAction(valueId);
      }}
      onMouseEnter={!isMobile ? () => onHoverAction(true, valueId) : null}
      onMouseLeave={!isMobile ? () => onHoverAction(false, valueId) : null}
    >
      {content.image ? (
        <div key={content.image}>
          {!customItem ? (
            <JBImage src={image || content.image} size="25vw" />
          ) : (
            customItem
          )}
        </div>
      ) : null}
      {content.textTitle ? (
        <div
          className="flex-1 text-left [&_span]:block"
          key={content.textTitle}
        >
          <span className="text-base text-gray font-bold pt-[.8rem] pr-0 pb-0 pl-[.3rem]">
            {content.textTitle}
          </span>
          <span className="text-sm font-bold text-gray-light2">
            {content.text}
          </span>
        </div>
      ) : null}
      {content.price && !isSelected ? (
        <div
          className="text-right pt-[.8rem] pr-4 pb-0 pl-0"
          key={content.price}
        >
          {content.price}
        </div>
      ) : null}
      {isSelected && (
        <div
          className={classNames('z-[3001]', {
            'items-center bg-gray-dark flex h-6 justify-center absolute right-[calc(1rem_-_15px)] top-[calc(1rem_-_15px)] w-6 rounded-none md:rounded-tr': isSelected,
            '[&_svg]:h-3.5 [&_svg]:w-3.5': isSelected,
            '[&_svg_path]:fill-white [&_svg_path]:stroke-white': isSelected,
          })}
        >
          <IconTick height="22px" width="22px" />
        </div>
      )}
    </button>
  );
};

PDPFullWidthImageAndTextOption.propTypes = {
  content: PropTypes.shape({
    image: PropTypes.string,
    textTitle: PropTypes.string,
    text: PropTypes.string,
    price: PropTypes.string,
  }),
  onClickAction: PropTypes.func,
  onHoverAction: PropTypes.func,
  valueId: PropTypes.number,
  sku: PropTypes.string,
  optionValueName: PropTypes.string,
  selectedId: PropTypes.number,
};

export default PDPFullWidthImageAndTextOption;
